import styled from 'styled-components';

export const Main = styled.div`
  width: 100%;
  display: ${props => (props.actived ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  margin-top: 68px;
  margin-bottom: 68px;
`;

export const Container = styled.div`
  max-width: 980px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media only screen and (max-width: 950px) {
    align-items: center;
  }
`;

export const Title = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  text-transform: uppercase;
  color: #475467;

  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
  }
`;

export const SubTitle = styled.h4`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #475467;

  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.1em;
  }
`;

export const Grid = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  column-gap: 46px;
  row-gap: 56px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 85px;

  @media only screen and (max-width: 950px) {
    justify-content: center;
    margin-top: 46px;
  }
`;
